export default "__VITE_ASSET__BG75tUks__"